import React from 'react';
import once from 'lodash/once';
import type { ErrorFlagRendererProps } from '../types.tsx';
import ErrorFlag from './error-flag/index.tsx';

export const getFlagManger = () => {
	let currentDisplayedFlag: string | null = null;

	const onShow = (id: string) => {
		currentDisplayedFlag = id;
	};

	const onHide = () => {
		currentDisplayedFlag = null;
	};

	return ({ id, error }: ErrorFlagRendererProps) => {
		if (currentDisplayedFlag && currentDisplayedFlag !== id) {
			return null;
		}

		onShow(id);

		return <ErrorFlag error={error} onDismiss={once(onHide)} />;
	};
};

export default getFlagManger();
